import { axiosPublic, axiosPrivate, axiosPrivateBelieve, axiosPrivateNew, BASE_URL_BELIEVE_NEW } from "../config/axios";
import axios from "axios";
import { ConnectionError } from "../utils/errors";

const ErrorHandle = (error) => {
    
    console.log(error)
    /*console.log(error.message)
    console.log(error.response)
    console.log(error.response.data)
    console.log(error.response.status)
    */
    if (error.response.status === 403) {
        console.log("TIENE QUE SALIR")
        window.location.reload();
    } else {
        throw new ConnectionError(error)
    }
}

const updateCabecera = async (_cabecera) => {
    try {
        let request = await axiosPrivate.put("reservas/booking_cabecera/" + _cabecera.id_cabecera, _cabecera)
        return request
    } catch (error) {
        ErrorHandle(error)
    }
};

const getSirvoyMovData = async (_id_hotel, _id) => {
    try {
        let request = await axiosPrivate.get(`/booking_mov/${_id_hotel}/${_id}`)
        return request
    } catch (error) {
        ErrorHandle(error)
    }
};

const traeParticipantes = async (_id) => {
    try {
        let request = await axiosPrivate.get("calendario_participantes/" + _id)
        return request
    } catch (error) {
        ErrorHandle(error)
    }
};

const traeAssets = async (_id_hotel) => {
    try {
        let request = await axiosPrivate.get("assets/" + _id_hotel)
        return request
    } catch (error) {
        ErrorHandle(error)
    }
};

const addParticipante = async (_datos_send) => {
    try {
        //let request = await axiosPrivate.post("calendario_participante", _datos_send);
        let request = await axiosPrivateNew.post("evento_participantes/", _datos_send);
        return request
    } catch (error) {
        ErrorHandle(error)
    }
};

const updateParticipante = async (_datos_send) => {
    try {
        let request = await axiosPrivate.put("calendario_participante/" + _datos_send.id, _datos_send);
        return request
    } catch (error) {
        ErrorHandle(error)
    }
};

const deleteParticipante = async (_id, _datos_evento={}) => {
    try {
        let request = await axiosPrivateNew.delete("evento_participantes/" + _id, {datos_evento:_datos_evento});
        return request
    } catch (error) {
        ErrorHandle(error)
    }
};

const asistioParticipante = async (_datos_send) => {
    try {
        //let request = await axiosPrivate.put("calendario_participante_asistencia/" + _datos_send.id, _datos_send);
        let request = await axiosPrivateNew.put("evento_participantes/assist/" + _datos_send.id, _datos_send);
        return request
    } catch (error) {
        ErrorHandle(error)
    }
};

const assetParticipante = async (_datos_send) => {
    try {
        let request = await axiosPrivate.put("calendario_participante_asset/" + _datos_send.id, _datos_send);
        return request
    } catch (error) {
        console.log(error)
        //ErrorHandle(error)
    }
};

const getEventos = async (id_hotel, desde, hasta, tipo) => {
    try {
        let request = await axiosPrivate.get("eventos/" + id_hotel + "/" + desde + "/" + hasta + "/" + tipo);
        return request
    } catch (error) {
        ErrorHandle(error)
    }
}

const getEvento = async (id) => {
    try {
        let request = await axiosPrivateNew.get(`eventos/${id}`);
        return request
    } catch (error) {
        ErrorHandle(error)
    }
}

const getIni = async (_data) => {
    try {
        let request = await axiosPrivateNew.get("data/conta_ini");
        let request_sellitems = await axiosPrivateNew.get("tickets/tickets_lista")
        let request_locations = await axiosPrivateNew.get(`actividades/locations`);

        request.data.tickets_lista=request_sellitems.data.data
        request.data.locations_lista=request_locations.data.data
        console.log(request.data)
        return request
    } catch (error) {
        console.log(error);
       // ErrorHandle(error)
    }
};

const getCategorias = async (_data) => {
    try {
        let request = await axiosPrivateNew.get("tienda/productos_categorias/0");
        return request
    } catch (error) {
        ErrorHandle(error)
    }
};

const addCategoria = async (_data) => {
    try {
        let request = await axiosPrivateNew.post("tienda/productos_categorias", _data);
        return request
    } catch (error) {
        ErrorHandle(error)
    }
};

const updateCategoria = async (_data) => {
    try {
        let request = await axiosPrivateNew.put("tienda/productos_categorias/" + _data.id, _data);
        return request
    } catch (error) {
        ErrorHandle(error)
    }
};

const deleteCategoria = async (_id) => {
    try {
        let request = await axiosPrivateNew.delete("tienda/productos_categorias/" + _id);
        return request
    } catch (error) {
        ErrorHandle(error)
    }
};

const getProductos = async (_data) => {
    try {
        let request = await axiosPrivateNew.get("tienda/productos/0/0");
        return request
    } catch (error) {
        ErrorHandle(error)
    }
};

const addProducto = async (_data) => {
    try {
        let request = await axiosPrivateNew.post("tienda/productos", _data);
        return request
    } catch (error) {
        ErrorHandle(error)
    }
};

const updateProducto = async (_data) => {
    try {
        let request = await axiosPrivateNew.put("tienda/productos/" + _data.id, _data);
        return request
    } catch (error) {
        ErrorHandle(error)
    }
};

const deleteProducto = async (_id) => {
    try {
        let request = await axiosPrivateNew.delete("tienda/productos/" + _id);
        return request
    } catch (error) {
        ErrorHandle(error)
    }
};

const getProductoConts = async (_id_producto) => {
    try {
        let request = await axiosPrivateNew.get("tienda/productos_contenido/" + _id_producto);
        return request
    } catch (error) {
        ErrorHandle(error)
    }
};

const addProductoCont = async (_data) => {
    try {
        let request = await axiosPrivateNew.post("tienda/productos_contenido", _data);
        return request
    } catch (error) {
        ErrorHandle(error)
    }
};

const updateProductoCont = async (_data) => {
    try {
        let request = await axiosPrivateNew.put("tienda/productos_contenido/" + _data.id, _data);
        return request
    } catch (error) {
        ErrorHandle(error)
    }
};

const deleteProductoCont = async (_id) => {
    try {
        let request = await axiosPrivateNew.delete("tienda/productos_contenido/" + _id);
        return request
    } catch (error) {
        ErrorHandle(error)
    }
};

const getProductoImgs = async (_id_producto) => {
    try {
        let request = await axiosPrivateNew.get("tienda/productos_imgs/" + _id_producto);
        return request
    } catch (error) {
        ErrorHandle(error)
    }
};

const addProductoImg = async (_data) => {
    try {
        //console.log(_data.getHeaders())
        let request = await axios.post(BASE_URL_BELIEVE_NEW + "tienda/productos_imgs", _data, {
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("BelieveToken"),
                "Content-Type": "multipart/form-data"
            }
        });
        return request
    } catch (error) {
        ErrorHandle(error)
    }
};

const deleteProductoImg = async (_id) => {
    try {
        let request = await axiosPrivateNew.delete("tienda/productos_imgs/" + _id);
        return request
    } catch (error) {
        ErrorHandle(error)
    }
};

const getReglasTemplates = async () => {
    try {
        let request = await axiosPrivateNew.get("reglas/reglas_templates");
        return request
    } catch (error) {
        ErrorHandle(error)
    }
};

const addPReglaTemplate = async (_data) => {
    try {
        let request = await axiosPrivateNew.post("reglas/reglas_template", _data);
        return request
    } catch (error) {
        ErrorHandle(error)
    }
};

const updateReglaTemplate = async (_data) => {
    try {
        let request = await axiosPrivateNew.put("reglas/reglas_template/" + _data.id, _data);
        return request
    } catch (error) {
        ErrorHandle(error)
    }
};

const deleteReglaTemplate = async (_id) => {
    try {
        let request = await axiosPrivateNew.delete("reglas/reglas_template/" + _id);
        return request
    } catch (error) {
        ErrorHandle(error)
    }
};

const getRoomsRel = async () => {
    try {
        let request = await axiosPrivateNew.delete("data/rooms_rel");
        return request
    } catch (error) {
        ErrorHandle(error)
    }
};

const getSirvoyObjeto = async (_id_hotel, _booking_n) => {
    try {
        let request = await axiosPrivateNew.get(`sirvoy/objeto/${_id_hotel}/${_booking_n}`);
        return request
    } catch (error) {
        ErrorHandle(error)
    }
};

const sendPrepayMail = async (_id_cabecera) => {
    try {
        let request = await axiosPrivateNew.post(`bookings/send_prepay`, { id: _id_cabecera });
        return request
    } catch (error) {
        ErrorHandle(error)
    }
};

const getBookingRooms = async (_id_hotel, _id_booking) => {
    try {
        let request = await axiosPrivateNew.get(`bookings/booking_rooms/${_id_hotel}/${_id_booking}`);
        return request
    } catch (error) {
        ErrorHandle(error)
    }
};

const ordena = async (_tabla, _ids) => {
    try {
        let request = await axiosPrivateNew.post(`tienda/ordena`, { tabla: _tabla, ids: _ids });
        return request
    } catch (error) {
        ErrorHandle(error)
    }
};

const getBooking = async (_id_hotel, _id_booking) => {
    try {
        let request = await axiosPrivateNew.get(`bookings/booking/${_id_hotel}/${_id_booking}`);
        return request
    } catch (error) {
        ErrorHandle(error)
    }
};

const updateCheck = async (_value, _id_booking) => {
    try {
        let data_send = {
            checkeo: _value,
        }
        let request = await axiosPrivateNew.put(`bookings/check_booking/${_id_booking}`, data_send);
        return request
    } catch (error) {
        ErrorHandle(error)
    }
};

const getCashbookComplete = async (_desde, _hasta, _id_hotel) => {
    try {
        let request = await axiosPrivateNew.get("/cashbook/complete/" + _desde + "/" + _hasta + "/" + _id_hotel)
        return request
    } catch (error) {
        ErrorHandle(error)
    }
};

const getCashbook = async (_desde, _hasta, _id_hotel, query=null) => {
    try {
        let queryString = query ? `?${query.join("&")}` : "";
        let request = await axiosPrivateNew.get("/cashbook/list/" + _desde + "/" + _hasta + "/" + _id_hotel+queryString)
        return request
    } catch (error) {
        ErrorHandle(error)
    }
};

const addMov = async (_mov) => {
    try {
        let request = await axiosPrivateNew.post(`/cashbook/movs`, _mov);
        return request
    } catch (error) {
        ErrorHandle(error)
    }
};
const updateMov = async (_mov) => {
    try {
        let request = await axiosPrivateNew.put(`cashbook/movs_cabecera/${_mov.id_cabecera}`, _mov);
        return request
    } catch (error) {
        ErrorHandle(error)
    }
};

const addMovItem = async (_item) => {
    try {
        let request = await axiosPrivateNew.post(`cashbook/movs_item`, _item);
        return request
    } catch (error) {
        ErrorHandle(error)
    }
};
const updateMovItem = async (_item) => {
    try {
        let request = await axiosPrivateNew.put(`cashbook/movs_item/${_item.id}`, _item);
        return request
    } catch (error) {
        ErrorHandle(error)
    }
};
const delMovItem = async (_item) => {
    try {
        let request = await axiosPrivateNew.delete(`cashbook/movs_item/${_item}`);
        return request
    } catch (error) {
        ErrorHandle(error)
    }
};

const addMovPago = async (_pago) => {
    try {
        let request = await axiosPrivateNew.post(`cashbook/movs_pago`, _pago);
        return request
    } catch (error) {
        ErrorHandle(error)
    }
};

const updateMovPago = async (_pago) => {
    try {
        let request = await axiosPrivateNew.put(`cashbook/movs_pago/${_pago.id}`, _pago);
        return request
    } catch (error) {
        ErrorHandle(error)
    }
};
const delMovPago = async (_pago) => {
    try {
        let request = await axiosPrivateNew.delete(`cashbook/movs_pago/${_pago}`);
        return request
    } catch (error) {
        ErrorHandle(error)
    }
};

const traeCuerpoMov = async (_id) => {
    try {
        let request = await axiosPrivateNew.get(`cashbook/mov/${_id}`);
        return request
    } catch (error) {
        ErrorHandle(error)
    }
};

const addDoc = async (_doc) => {
    try {
        let request = await axiosPrivateNew.get(`cashbook/mov_docs`, _doc);
        return request
    } catch (error) {
        ErrorHandle(error)
    }
};

const getStock = async (_id_hotel) => {
    try {
        let request = await axiosPrivateNew.get(`cashbook/stock/${_id_hotel}`);
        return request
    } catch (error) {
        ErrorHandle(error)
    }
};

const getCuentas = async (_ids) => {
    try {
        let request = await axiosPrivateNew.get(`cashbook/cuentas/${_ids.join(",")}`);
        return request
    } catch (error) {
        ErrorHandle(error)
    }
};

const checkCabecera = async (_id, _campo, _value) => {
    try {
        let request = await axiosPrivateNew.put("booking/booking_field/" + _id, { [_campo]: _value })
        return request
    } catch (error) {
        ErrorHandle(error)
    }
};

const validaBnumber = async (_email) => {
    try {
        let request = await axiosPrivateNew.get("reportes/valida_b_numbers/" + _email)
        return request
    } catch (error) {
        ErrorHandle(error)
    }
};

const getBnumber = async (_bnumber) => {
    try {
        let request = await axiosPrivateNew.get("data/b_numbers", _bnumber)
        return request
    } catch (error) {
        ErrorHandle(error)
    }
};

const addBnumber = async (_bnumber) => {
    try {
        let request = await axiosPrivateNew.post("data/b_numbers", _bnumber)
        return request
    } catch (error) {
        ErrorHandle(error)
    }
};

const updateBnumber = async (_bnumber) => {
    try {
        let request = await axiosPrivateNew.post("data/b_numbers/" + _bnumber.id, _bnumber)
        return request
    } catch (error) {
        ErrorHandle(error)
    }
};

const linkBnumber = async (_data) => {
    try {
        let request = await axiosPrivateNew.post("reservas/cabecera_bnumber", _data)
        return request
    } catch (error) {
        ErrorHandle(error)
    }
};

const getBookingBnumbers = async (_id_cabecera) => {
    try {
        let request = await axiosPrivateNew.get("reservas/cabecera_bnumber/" + _id_cabecera);
        return request
    } catch (error) {
        ErrorHandle(error)
    }
};

const getBookingCabeceras = async (_id_hotel_def, _tipo_fecha, _desde, _hasta, _id) => {
    try {
        const request = await axiosPrivateNew.get("bookings/bookings_cabecera/" + _id_hotel_def + "/" + _tipo_fecha + "/" + _desde + "/" + _hasta + (_id > 0 ? "/" + _id : ""))
        return request
    } catch (error) {
        ErrorHandle(error)
    }
}

const getOrdenesPago = async (_id_hotel_def, _origen, _desde, _hasta, _estado) => {
    try {
        const request = await axiosPrivateNew.get("ordenes_pago/" + _id_hotel_def + "/" + _origen + "/" + _desde + "/" + _hasta + "/" + _estado)
        return request
    } catch (error) {
        ErrorHandle(error)
    }
}

const getOrdenPago = async (_tipo, _ref) => {
    try {
        const request = await axiosPrivateNew.get("ordenes_pago/orden/" + _tipo + "/" + _ref)
        return request
    } catch (error) {
        ErrorHandle(error)
    }
}

const getLocations = async () => {
    try {
        let request = await axiosPrivateNew.get(`actividades/locations`);
        return request
    } catch (error) {
        ErrorHandle(error)
    }
};

const getSurfLevels = async () => {
    try {
        let request = await axiosPrivateNew.get(`actividades/surfLevels`);
        return request
    } catch (error) {
        ErrorHandle(error)
    }
};

const getActivities = async (id_tipo=0) => {
    try {
        console.log(`actividades/activities/${id_tipo}`)
        let request = await axiosPrivateNew.get(`actividades/activities/${id_tipo}`);
        return request
    } catch (error) {
        ErrorHandle(error)
    }
};

const getEnquiry = async (_id) => {
    try {
        let request = await axiosPrivateNew.get(`enquiries/${_id}`);
        return request
    } catch (error) {
        ErrorHandle(error)
    }
};

const updateEnquiryStat = async (_id, _stat) => {
    try {
        let request = await axiosPrivateBelieve.put("/enquiries/stat/" + _id, { status: _stat })
        return request
    } catch (error) {
        ErrorHandle(error)
    }
};

const addCabeceraEnquiryRel = async (_data) => {
    try {
        let request = await axiosPrivateNew.post("/enquiries/cabecera_enquiry_rel/", _data)
        return request
    } catch (error) {
        ErrorHandle(error)
    }
};

const delCabeceraEnquiryRel = async (_id) => {
    try {
        let request = await axiosPrivateNew.delete("/enquiries/cabecera_enquiry_rel/" + _id)
        return request
    } catch (error) {
        ErrorHandle(error)
    }
}

const traeCabeceraEnquiryRel = async (_origen, _id) => {
    try {
        let request = await axiosPrivateNew.get("/enquiries/cabecera_enquiry_rel/" + _origen + "/" + _id)
        return request
    } catch (error) {
        ErrorHandle(error)
    }
};

const getBookingCalendar = async (id_hotel, desde, hasta) => {
    try {
        console.log(id_hotel, desde, hasta)
        let request = await axiosPrivateNew.get("bookings/booking_calendar/" + id_hotel + "/" + desde + "/" + hasta);
        return request
    } catch (error) {
        console.log(error)
        //ErrorHandle(error)
    }

}

const getTienda = async () => {
    try {
        let request = await axiosPrivateNew.get("public/tienda");
        return request.data
    } catch (error) {
        ErrorHandle(error)
    }
}

const getIdentification = async (_data) => {
    try {
        let _bnumber = await axiosPrivateNew.post("tienda/identification", _data);
        return  _bnumber.data
    } catch (error) {
        ErrorHandle(error)
    }
}

const sendPedido = async (_data) => {
    try {
        let _pedido = await axiosPrivateNew.post("tienda/pedido", _data);
        return  _pedido.data
    } catch (error) {
        console.log(error)
        //ErrorHandle(error)
    }
}


const getTickets = async (_id_hotel_def, _tipo, _desde, _hasta, _estado) => {
    try {
        const request = await axiosPrivateNew.get("tickets/" + _id_hotel_def + "/" + _tipo + "/" + _desde + "/" + _hasta + "/" + _estado)
        return request
    } catch (error) {
        ErrorHandle(error)
    }
}

const getTicket = async (_id) => {
    try {
        const request = await axiosPrivateNew.get("tickets/ticket/" + _id)
        return request
    } catch (error) {
        ErrorHandle(error)
    }
}

const sendTicket = async (_ticket) => {
    try {
        let request
        if (_ticket.hasOwnProperty("id") && _ticket.id && _ticket.id>0) {
            request = await axiosPrivateNew.put(`tickets/ticket/${_ticket.id}`, _ticket);
        } else {
            request = await axiosPrivateNew.post(`tickets/ticket`, _ticket);
        }
        return request
    } catch (error) {
        console.log(error)
        //ErrorHandle(error)
    }
}

export const transferTicket = async ({id_ticket, id_destino}) => {
    try {
        let request = await axiosPrivateNew.put(`tickets/transfer/${id_ticket}`, {id_ticket,id_destino});
        return request
    } catch (error) {
        console.log(error)
        //ErrorHandle(error)
    }
}

export const liberaTicket = async ({id_ticket}) => {
    try {
        let request = await axiosPrivateNew.put(`tickets/libera/${id_ticket}`);
        return request
    } catch (error) {
        console.log(error)
        //ErrorHandle(error)
    }
}

const setOrdenCargada = async (_id, _cargada) => {
    try {
        let request = await axiosPrivateNew.put("ordenes_pago/cargada/" + _id, { cargada: _cargada });
        return request
    } catch (error) {
        ErrorHandle(error)
    }
};

const getSuppliers = async (term = '') => {
    try {
        let request = await axiosPrivateNew.get("suppliers/manage" + (term ? `?term=${encodeURIComponent(term)}` : ''));
        return request
    } catch (error) {
        ErrorHandle(error)
    }
}

const sendSupplier = async (_supplier) => {
    try {
        let request
        if (_supplier.hasOwnProperty("id") && parseInt(_supplier.id) > 0) {
            request = await axiosPrivateNew.put("suppliers/manage/" + _supplier.id, _supplier);
        } else {
            request = await axiosPrivateNew.post("suppliers/manage", _supplier);
        }
        return request
    } catch (error) {
        ErrorHandle(error)
    }
}

const delSupplier = async (_id) => {
    try {
        let request = await axiosPrivateNew.delete("suppliers/manage/" + _id);
        return request
    } catch (error) {
        ErrorHandle(error)
    }
}

export const getInstructorsList = async (cat, term = '') => {
    try {
        let request = await axiosPrivateNew.get(`suppliers/manage/instructors/${cat}/${term}`);
        return request
    } catch (error) {
        ErrorHandle(error)
    }
}


const getSupplierActs = async (id_hotel, id_supplier, desde, hasta, estado) => {
    try {
        let request = await axiosPrivateNew.get("suppliers/" + id_hotel + "/" + id_supplier + "/" + desde + "/" + hasta + (estado != "" ? "/" + estado : ""));
        return request
    } catch (error) {
        ErrorHandle(error)
    }
}

const getSupplierAct = async (id) => {
    try {
        let request = await axiosPrivateNew.get("suppliers/" + id);
        return request
    } catch (error) {
        ErrorHandle(error)
    }
}

const addSupplierAct = async (data) => {
    try {
        let request = await axiosPrivateNew.post("suppliers/", data);
        return request
    } catch (error) {
        ErrorHandle(error)
    }
}

const updateSupplierAct = async (data) => {
    try {
        let request = await axiosPrivateNew.put("suppliers/" + data.id, data);
        return request
    } catch (error) {
        ErrorHandle(error)
    }
}

const deleteSupplierAct = async (_id) => {
    try {
        let request = await axiosPrivateNew.delete("suppliers/" + _id);
        return request
    } catch (error) {
        ErrorHandle(error)
    }
}

const setSupplierInOut = async (data) => {
    try {
        let request = await axiosPrivateNew.put("suppliers/out/" + data.id, data);
        return request
    } catch (error) {
        ErrorHandle(error)
    }
}

const getSupplierActPending = async (id_supplier) => {
    try {
        let request = await axiosPrivateNew.get("suppliers/pending/" + id_supplier);
        return request
    } catch (error) {
        ErrorHandle(error)
    }
}

const getSupplierContracts = async (id_supplier = 0, desde = 0, hasta = 0, estado = 0, id_contrato = null) => {
    try {
        let request = await axiosPrivateNew.get("suppliers/contracts/" + id_supplier + "/" + desde + "/" + hasta + "/" + estado + (id_contrato ? "/" + id_contrato : ""));
        return request
    } catch (error) {
        ErrorHandle(error)
    }
}

const addSupplierContract = async (data) => {
    try {
        let request = await axiosPrivateNew.post("suppliers/contracts", data);
        return request
    } catch (error) {
        ErrorHandle(error)
    }
}

const updateSupplierContract = async (data) => {
    try {
        let request = await axiosPrivateNew.put("suppliers/contracts/" + data.id, data);
        return request
    } catch (error) {
        ErrorHandle(error)
    }
}

const deleteSupplierContract = async (_id) => {
    try {
        let request = await axiosPrivateNew.delete("suppliers/contracts" + _id);
        return request
    } catch (error) {
        ErrorHandle(error)
    }
}

const getSupplierReceipts = async (id_hotel, id_supplier, desde, hasta) => {
    try {
        console.log(id_hotel, desde, hasta)
        let request = await axiosPrivateNew.get(`suppliers/receipts/${id_hotel}/${id_supplier}/${desde}/${hasta}`)
        return request
    } catch (error) {
        console.log(error)
        //ErrorHandle(error)
    }

}

const getSupplierReceipt = async (_id) => {
    try {
        let request = await axiosPrivateNew.get(`suppliers/receipt/${_id}`);
        return request
    } catch (error) {
        console.log(error)
        //ErrorHandle(error)
    }

}

const addSupplierReceipt = async (_receipt) => {
    try {
        let request = await axiosPrivateNew.post(`suppliers/receipt`, _receipt);
        return request
    } catch (error) {
        console.log(error)
        //ErrorHandle(error)
    }
}

const updateSupplierReceipt = async (_receipt) => {
    try {
        let request = await axiosPrivateNew.put(`suppliers/receipt/${_receipt.id}`, _receipt);
        return request
    } catch (error) {
        console.log(error)
        //ErrorHandle(error)
    }

}

const deleteSupplierReceipt = async (_id) => {
    try {
        let request = await axiosPrivateNew.delete(`suppliers/receipt/${_id}`);
        return request
    } catch (error) {
        console.log(error)
        //ErrorHandle(error)
    }

}

const getSupplierReceiptHs = async (_id) => {
    try {
        let request = await axiosPrivateNew.get(`suppliers/receipt_hours/${_id}`);
        return request
    } catch (error) {
        console.log(error)
        //ErrorHandle(error)
    }

}

const addSupplierReceiptHs = async (_receipt_hs) => {
    try {
        let request = await axiosPrivateNew.post(`suppliers/receipt_hours`, _receipt_hs);
        return request
    } catch (error) {
        console.log(error)
        //ErrorHandle(error)
    }

}

const deleteSupplierReceiptHs = async (_id) => {
    try {
        let request = await axiosPrivateNew.delete(`suppliers/receipt_hours/${_id}`);
        return request
    } catch (error) {
        console.log(error)
        //ErrorHandle(error)
    }

}

export const addSupplierPayment = async (_payment) => {
    try {
        let request = await axiosPrivateNew.post(`cashbook/generate_payment`, _payment);
        return request
    } catch (error) {
        console.log(error)
        //ErrorHandle(error)
    }
}

const getAssets = async (_id_hotel) => {
    try {
        let request = await axiosPrivateNew.get(`assets/${_id_hotel}`);
        return request
    } catch (error) {
        console.log(error)
        //ErrorHandle(error)
    }

}

const addAsset = async (_asset) => {
    try {
        let request = await axiosPrivateNew.post(`assets`, _asset);
        return request
    } catch (error) {
        console.log(error)
        //ErrorHandle(error)
    }

}
const updateAsset = async (_asset) => {
    try {
        let request = await axiosPrivateNew.put(`assets/${_asset.id}`, _asset);
        return request
    } catch (error) {
        console.log(error)
        //ErrorHandle(error)
    }
}

const deleteAsset = async (_id) => {
    try {
        let request = await axiosPrivateNew.delete(`assets/${_id}`);
        return request
    } catch (error) {
        console.log(error)
        //ErrorHandle(error)
    }

}

const getSuscripciones = async (id_hotel, tipo, desde, hasta, id_bnumber = null,availables=0) => {
    try {
        console.log(id_hotel, desde, hasta)
        let request = await axiosPrivateNew.get(`tickets/suscripciones/${id_hotel}/${tipo}/${desde}/${hasta}${id_bnumber ? "/" + id_bnumber : ""}${availables?"?availables="+availables:""}`)
        return request.data.data
    } catch (error) {
        console.log(error)
        //ErrorHandle(error)
    }
}

export const getSuscripcionesReport = async (id_hotel, tipo, desde, hasta,availables=0) => {
    try {
        console.log(id_hotel, desde, hasta)
        let request = await axiosPrivateNew.get(`tickets/suscripciones_report/${id_hotel}/${tipo}/${desde}/${hasta}${availables?"?availables="+availables:""}`)
        return request.data.data
    } catch (error) {
        console.log(error)
        //ErrorHandle(error)
    }
}

const getSuscripcion = async (_id) => {
    try {
        let request = await axiosPrivateNew.get(`tickets/suscripcion/${_id}`)
        return request
    } catch (error) {
        console.log(error)
        //ErrorHandle(error)
    }
}

const sendSuscripcion = async (_suscripcion) => {
    console.log(_suscripcion)
    try {
        let request
        if (_suscripcion.hasOwnProperty("id")) {
            request = await axiosPrivateNew.put(`tickets/suscripcion/${_suscripcion.id}`, _suscripcion);
        } else {
            request = await axiosPrivateNew.post(`tickets/suscripcion`, _suscripcion);
        }
        return request
    } catch (error) {
        console.log(error)
        //ErrorHandle(error)
    }

}

const getMeanPayments = async (_desde, _hasta) => {
    try {
        let request = await axiosPrivateNew.get(`reportes/mean_payments/${_desde}/${_hasta}`);
        return request
    } catch (error) {
        console.log(error)
        //ErrorHandle(error)
    }
}

const getInforme = async (_id_hotel, _desde, _hasta, _solo_venta=false) => {
    try {
        console.log("SOLO VENTA",_solo_venta)
        let request = await axiosPrivateNew.get(`reportes/informe/${_id_hotel}/${_desde}/${_hasta}${_solo_venta?'?solo_venta=true':''}`);
        return request
    } catch (error) {
        console.log(error)
        //ErrorHandle(error)
    }
}

const getCajaStat = async (_id_hotel, _origen = "") => {
    console.log(_origen)
    try {
        let request = await axiosPrivateNew.get(`reportes/caja_stat_new/${_id_hotel}`);
        return request
    } catch (error) {
        console.log(error)
        //ErrorHandle(error)
    }
}

const searchItems = async (_term) => {
    try {
        let request = await axiosPrivate.get(`products/${_term}`);
        return request.data
    } catch (error) {
        console.log(error)
        //ErrorHandle(error)
    }
}

const transfiereParticipante = async (_id_participante, _id_destino) => {
    try {
        let request = await axiosPrivateNew.put(`eventos/transfiere_participante/${_id_participante}`,{id_evento_destino:_id_destino});
        return request.data
    } catch (error) {
        console.log(error)
    }
}

const getPartipantesNovedades = async (_id_participante, _id_destino) => {
    try {
        let request = await axiosPrivateNew.get(`eventos/novedades`);
        return request.data
    } catch (error) {
        console.log(error)
    }
}

const getLafiseTransactions = async (from, to, pag) => {
    try {
        let request = await axiosPrivateNew.get(`lafise_gral/history/${from.replace("-","").replace("-","")}/${to.replace("-","").replace("-","")}/${pag}`);
        return JSON.parse(request.data.data).data
    } catch (error) {
        console.log(error)
    }
}

const getAvailableTickets = async (_id_bnumber, _tipo) => {
    try {
        let request = await axiosPrivateNew.get(`tickets/tickets_availables/${_id_bnumber}/${_tipo}`);
        return request.data.tickets
    } catch (error) {
        console.log(error)
    }
}

const getAvailableSuscripciones = async (_id_bnumber, _tipo,_fecha_evento=null) => {
    try {
        let request = await axiosPrivateNew.get(`tickets/suscripciones_availables/${_id_bnumber}/${_tipo}${_fecha_evento?"?date="+_fecha_evento:""}`);
        return request.data.suscripciones
    } catch (error) {
        console.log(error)
    }
}

const getEnquiries = async (from, to) => {
    try {
        let request = await axiosPrivateBelieve.get(`/enquiries/${from}/${to}`);
        return request.data
    } catch (error) {
        console.log(error)
    }
}

const getSupplierReceiptsResume = async (id_hotel) => {
    try {
        let request = await axiosPrivateNew.get(`/suppliers/receipts_resumen/${id_hotel}`);
        return request.data
    } catch (error) {
        console.log(error)
    }
}

const getCotizacion = async ()=>{
    try {
        let request = await axios.get(`https://tipodecambio.paginasweb.cr/api`);
        return request.data
    } catch (error) {
        console.log(error)
    }
}

const updateMovStatus = async (_id,_status) => {
    try {
        let request = await axiosPrivateNew.put(`/cashbook/movs_cabecera_status/${_id}`,{status:_status});
        return request.data
    } catch (error) {
        console.log(error)
        //ErrorHandle(error);
    }
}

const getFacturaCompra = async (_id) => {
    try {
        let request = await axiosPrivate.get(`factura_compra/${_id}`);
        return request
    } catch (error) {
        console.log(error)
        ErrorHandle(error);
    }
}

const sendFactura = async (factura) => {
    try {
        let request = await axiosPrivate.post(`factura`, factura);
        return request
    } catch (error) {
        console.log(error)
        ErrorHandle(error);
    }
}

const getActivitiesItems = async ({tipo=0,disciplina=0}) => {
    try {
        let request = await axiosPrivateNew.get(`actividades/calendario_items/${tipo}/${disciplina}`);
        return request
    } catch (error) {
        console.log(error)
        ErrorHandle(error);
    }
}

const getActivitiesAnt = async () => {
    try {
        let request = await axiosPrivate.get(`activities`);
        return request
    } catch (error) {
        console.log(error)
        ErrorHandle(error);
    }
}

const getFormats = async () => {
    try {
        let request = await axiosPrivate.get(`activity_format`);
        return request
    } catch (error) {
        console.log(error)
        ErrorHandle(error);
    }
}

const cierraEventoReq = async (id_evento,data) => {
    try {
        let request = await axiosPrivateNew.put(`eventos/cierra_evento/${id_evento}`,data);
        return request
    } catch (error) {
        console.log(error)
        ErrorHandle(error);
    }
}

const addEvento = async (data) => {
    try {
        let request = await axiosPrivateNew.post(`eventos`,data);
        return request
    } catch (error) {
        console.log(error)
        ErrorHandle(error);
    }
}

const updateEvento = async (id_evento,data) => {
    try {
        let request = await axiosPrivateNew.put(`eventos/${id_evento}`,data);
        return request
    } catch (error) {
        console.log(error)
        ErrorHandle(error);
    }
}

const getEventosLista = async (_id_hotel, _id_tipo,_desde=null,_hasta=null)=>{
    try {
        let request = await axiosPrivateNew.get(`eventos/?${_id_hotel!=0?"&hotel="+_id_hotel:""}${_id_tipo!=0?"&tipo="+_id_tipo:""}${_desde?"&desde="+_desde:""} ${_hasta!=0?"&hasta="+_hasta:""}`);
        return request.data.data
    } catch (error) {
        console.log(error)
        ErrorHandle(error);
    }
}

const cierraReceipt = async (_id, _data)=>{
    console.log("ENTRE AL CIERE")
    try {
        let request = await axiosPrivateNew.put(`/suppliers/cierra_receipt/${_id}`,_data);
        return request.data
    } catch (error) {
        console.log(error)
        ErrorHandle(error);
    }
}

const getReceiptExtras= async (_id)=>{
    try {
        let request = await axiosPrivateNew.get(`/suppliers/receipt_extras/${_id}`);
       console.log(request.data)
        return request.data.data
    } catch (error) {
        console.log(error)
       // ErrorHandle(error);
    }
}

const addReceiptExtras= async (_data)=>{
    try {
        let request = await axiosPrivateNew.post(`/suppliers/receipt_extras`,{..._data, estado:1});
        console.log(request)
        return request.data.data
    } catch (error) {
        console.log(error)
        ErrorHandle(error);
    }
}

const updateReceiptExtras= async (_id, _data)=>{
    try {
        let request = await axiosPrivateNew.update(`/suppliers/receipt_extras/${_id}`,_data);
        return request.data.data
    } catch (error) {
        console.log(error)
        ErrorHandle(error);
    }
}

const deleteReceiptExtras= async (_id)=>{
    try {
        let request = await axiosPrivateNew.delete(`/suppliers/receipt_extras/${_id}`);
        return request.data.data
    } catch (error) {
        console.log(error)
        ErrorHandle(error);
    }
}

const getSupplierHoursPending= async (_data)=>{
    try {
        let query = []
        if(_data.id_hotel) query.push("id_hotel="+_data.id_hotel)
        if(_data.id_supplier) query.push("id_supplier="+_data.id_supplier)
        let request = await axiosPrivateNew.get(`/suppliers/pending_hours/?${query.join("&")}`);
        return request.data.data
    } catch (error) {
        console.log(error)
        ErrorHandle(error);
    }
}

const getSellItems = async () => {
    try {        
        let request = await axiosPrivateNew.get("/tienda/sell_items")
        return request.data
    } catch (error) {
        ErrorHandle(error)
    }
};

const getFacturas = async (filtros) => {
    try {
        // Construir query params dinámicamente
        const queryParams = new URLSearchParams();

        // Iterar sobre los filtros y agregar solo los que tienen valor
        Object.keys(filtros).forEach(key => {
            const value = filtros[key];

            // Agregar solo si tiene valor (no vacío, no null, no undefined)
            if (value !== "" && value !== null && value !== undefined) {
                queryParams.append(key, value);
            }
        });

        // Construir la URL con los parámetros
        const url = `/facturas${queryParams.toString() ? `?${queryParams.toString()}` : ''}`;

        let request = await axiosPrivateNew.get(url);
        return request.data;
    } catch (error) {
        ErrorHandle(error);
    }
};

const getBankAccounts = async () => {
    try {
        let request = await axiosPrivateNew.get(`/cashbook/bank_accounts`);
        return request.data;
    } catch (error) {
        ErrorHandle(error);
    }
};

const searchBanks = async (term) => {
    try {
        let request = await axiosPrivateNew.get(`/cashbook/banks`, { params: { term } });
        return request.data;
    } catch (error) {
        ErrorHandle(error);
    }
};

const createBank = async (nombre) => {
    try {
        let request = await axiosPrivateNew.post(`/cashbook/banks`, { nombre });
        return request.data;
    } catch (error) {
        ErrorHandle(error);
    }
};

const getBankAccountsFull = async () => {
    try {
        let request = await axiosPrivateNew.get(`/cashbook/bank_accounts_full`);
        return request.data;
    } catch (error) {
        ErrorHandle(error);
    }
};

const createBankAccount = async (data) => {
    try {
        let request = await axiosPrivateNew.post(`/cashbook/bank_accounts`, data);
        return request.data;
    } catch (error) {
        ErrorHandle(error);
    }
};

const updateBankAccount = async (id, data) => {
    try {
        let request = await axiosPrivateNew.patch(`/cashbook/bank_accounts/${id}`, data);
        return request.data;
    } catch (error) {
        ErrorHandle(error);
    }
};

const deleteBankAccount = async (id) => {
    try {
        let request = await axiosPrivateNew.delete(`/cashbook/bank_accounts/${id}`);
        return request.data;
    } catch (error) {
        ErrorHandle(error);
    }
};

const updateOrdenCuenta = async (id, id_cuenta_bancaria) => {
    try {
        let request = await axiosPrivateNew.patch(`/cashbook/ordenes/${id}/cuenta`, {
            id_cuenta_bancaria
        });
        return request.data;
    } catch (error) {
        ErrorHandle(error);
        throw error;
    }
};

const batchPayOrdenes = async ({ tipo,orden_ids }) => {
    try {
        let request = await axiosPrivateNew.post(`/cashbook/ordenes/batch-pay`, {
            tipo,
            orden_ids
        });
        return request.data;
    } catch (error) {
        ErrorHandle(error);
        throw error;
    }
};

export const relacionaFacturaMovimiento = async (id_factura, id_movimiento) => {
    try {        
        let request = await axiosPrivateNew.patch(`/facturas/movimiento/${id_factura}`,{id_movimiento:id_movimiento})
        return request.data
    } catch (error) {
        ErrorHandle(error)
    }
};

const submitTienda = async (data) => {
    try {        
        let request = await axiosPrivateNew.post("/tienda/tienda_cashbook",data)
        return request.data
    } catch (error) {
        ErrorHandle(error)
    }
};

export const getDatosAperturaCierre = async (id_hotel)=>{
    try {        
        let request = await axiosPrivate.get(`/datos_cierreapertura/${id_hotel}`)
        return request.data
    } catch (error) {
        ErrorHandle(error)
    }
}

export const getMovimientos = async (query) => {
    try {        
        console.log(query)
        let request = await axiosPrivateNew.get(`/cashbook/movimientos/${query}`)
        return request.data
    } catch (error) {
        console.log(error);
        //ErrorHandle(error)
    }
};

export const getSupplierPaymentOrders = async (query) => {
    try {        
        let request = await axiosPrivateNew.get(`/cashbook/supplier_order_payments/${query}`)
        return request.data
    } catch (error) {
        console.log(error);
        //ErrorHandle(error)
    }
};

export const addSupplierOrder = async (data) => {
    try {        
        let request = await axiosPrivateNew.post(`/cashbook/supplier_order_payments`, data)
        return request.data
    } catch (error) {
        ErrorHandle(error)
    }
};

export const updateSupplierOrder = async (data) => {
    try {        
        let request = await axiosPrivateNew.patch(
          `/cashbook/supplier_order_payments/${data.id}`,
          data
        );
        console.log(request);
        return request.data
    } catch (error) {
        ErrorHandle(error)
    }
};

export const getCalendario = async (id_hotel, desde, hasta, tipo) => {
  try {
    let request = await axiosPrivate.get(`calendario/${id_hotel}/${desde}/${hasta}${tipo && tipo>0?"/"+tipo:""}`);
    console.warn(request);
    return request.data.data;
  } catch (error) {
    ErrorHandle(error);
  }
};

export const delEvento = async (_id)=>{
    try {
        let request = await axiosPrivateNew.delete(`eventos/${_id}`);
        return request.data.data
    } catch (error) {
        console.log(error)
        ErrorHandle(error);
    }
}

export const abreEvento = async (_id)=>{
    try {
        let request = await axiosPrivateNew.put(`eventos/abre_evento/${_id}`);
        return request.data.data
    } catch (error) {
        console.log(error)
        ErrorHandle(error);
    }
}

export const addBankStatement = async (data) => {
    try {
        let request = await axiosPrivateNew.post(`/bank/statements`, data)
        return request.data
    } catch (error) {
        ErrorHandle(error)
    }
}

export const getBankStatements = async (params) => {
    try {
        let request = await axiosPrivateNew.get(`/bank/statements`, { params })
        return request.data
    } catch (error) {
        ErrorHandle(error)
    }
}

export const deleteBankStatement = async (id) => {
    try {
        let request = await axiosPrivateNew.delete(`/bank/statements/${id}`)
        return request.data
    } catch (error) {
        ErrorHandle(error)
    }
}

export const getBankMovimientos = async (params) => {
    try {
        let request = await axiosPrivateNew.get(`/bank/statement_movimientos`, { params })
        return request.data
    } catch (error) {
        ErrorHandle(error)
    }
}

export const getIcals = async () => {
    const request = await axiosPublic.get(`${BASE_URL_BELIEVE_NEW}public/icals`)
    return request.data
}

// --- Órdenes de pago ---

export const createOrdenPago = async (data) => {
    try {
        let request = await axiosPrivateNew.post(`/cashbook/ordenes`, data)
        return request.data
    } catch (error) {
        ErrorHandle(error)
    }
}

export const deleteOrdenMovRel = async (id) => {
    try {
        const request = await axiosPrivateNew.delete(`/cashbook/orders_movs_rel/${id}`);
        return request.data;
    } catch (error) { ErrorHandle(error); }
}

export const deleteOrdenFactRel = async (id) => {
    try {
        const request = await axiosPrivateNew.delete(`/cashbook/orders_fact_rel/${id}`);
        return request.data;
    } catch (error) { ErrorHandle(error); }
}

export const deleteOrdenBankRel = async (id) => {
    try {
        const request = await axiosPrivateNew.delete(`/cashbook/orders_bank_rel/${id}`);
        return request.data;
    } catch (error) { ErrorHandle(error); }
}

export const addOrdenMovRel = async (data) => {
    try {
        let request = await axiosPrivateNew.post(`/cashbook/orders_movs_rel`, data)
        return request.data
    } catch (error) {
        ErrorHandle(error)
    }
}

export const addOrdenFactRel = async (data) => {
    try {
        let request = await axiosPrivateNew.post(`/cashbook/orders_fact_rel`, data)
        return request.data
    } catch (error) {
        ErrorHandle(error)
    }
}

export const addOrdenBankRel = async (data) => {
    try {
        let request = await axiosPrivateNew.post(`/cashbook/orders_bank_rel`, data)
        return request.data
    } catch (error) {
        ErrorHandle(error)
    }
}

export const getSupplierBankAccounts = async (id_supplier) => {
    try {
        let request = await axiosPrivateNew.get(`/cashbook/supplier_bank_accounts?id_supplier=${id_supplier}`)
        return request.data
    } catch (error) {
        ErrorHandle(error)
    }
}

export const addSupplierBankAccount = async (data) => {
    try {
        let request = await axiosPrivateNew.post(`/cashbook/supplier_bank_accounts`, data)
        return request.data
    } catch (error) {
        ErrorHandle(error)
    }
}

export const updateSupplierBankAccount = async (data) => {
    try {
        let request = await axiosPrivateNew.patch(`/cashbook/supplier_bank_accounts/${data.id}`, data)
        return request.data
    } catch (error) {
        ErrorHandle(error)
    }
}

export const getOrdenesList = async (filters = {}) => {
    try {
        const params = new URLSearchParams();
        Object.entries(filters).forEach(([k, v]) => {
            if (v !== '' && v !== null && v !== undefined) params.append(k, v);
        });
        const url = `/cashbook/ordenes${params.toString() ? `?${params}` : ''}`;
        const request = await axiosPrivateNew.get(url);
        return request.data;
    } catch (error) {
        ErrorHandle(error);
    }
}

export const getOrdenDetail = async (id) => {
    try {
        const request = await axiosPrivateNew.get(`/cashbook/ordenes/${id}`);
        return request.data;
    } catch (error) {
        ErrorHandle(error);
    }
}

export const updateOrdenData = async (id, data) => {
    try {
        const request = await axiosPrivateNew.patch(`/cashbook/ordenes/${id}`, data);
        return request.data;
    } catch (error) {
        ErrorHandle(error);
    }
}

export const deleteOrden = async (id) => {
    try {
        const request = await axiosPrivateNew.patch(`/cashbook/ordenes/${id}`, { estado: 3 });
        return request.data;
    } catch (error) {
        ErrorHandle(error);
    }
}

export const getSubrubros = async (id_rubro = 0) => {
    try {
        const url = id_rubro ? `subrubros/${id_rubro}` : 'subrubros';
        let request = await axiosPrivate.get(url);
        return request.data;
    } catch (error) {
        ErrorHandle(error);
    }
}

export const getSupplierById = async (id) => {
    try {
        let request = await axiosPrivateNew.get(`/cashbook/supplier/${id}`)
        return request.data
    } catch (error) {
        ErrorHandle(error)
    }
}

export const getSupplierProfile = async (id_supplier) => {
    try {
        let request = await axiosPrivateNew.get(`/cashbook/supplier_profile/${id_supplier}`)
        return request.data
    } catch (error) {
        ErrorHandle(error)
    }
}

export const saveSupplierProfile = async (data) => {
    try {
        let request = await axiosPrivateNew.patch(`/cashbook/supplier_profile/${data.id_supplier}`, data)
        return request.data
    } catch (error) {
        ErrorHandle(error)
    }
}

export const getMenuAdmin = async (tipo) => {
    try {
        let request = await axiosPrivateNew.get(`menu_admin/${tipo}`)
        return request.data
    } catch (error) {
        ErrorHandle(error)
    }
}

export const updateMenuOption = async (id, data) => {
    try {
        let request = await axiosPrivateNew.put(`menu_admin/${id}`, data)
        return request.data
    } catch (error) {
        ErrorHandle(error)
    }
}

export const toggleMenuEstado = async (id, estado) => {
    try {
        let request = await axiosPrivateNew.patch(`menu_admin/${id}/estado`, { estado })
        return request.data
    } catch (error) {
        ErrorHandle(error)
    }
}

export const reorderMenu = async (items) => {
    try {
        let request = await axiosPrivateNew.put(`menu_admin/reorder`, { items })
        return request.data
    } catch (error) {
        ErrorHandle(error)
    }
}

export {
    getCategorias,
    addCategoria,
    updateCategoria,
    deleteCategoria,
    getProductos,
    addProducto,
    updateProducto,
    deleteProducto,
    getProductoConts,
    addProductoCont,
    updateProductoCont,
    deleteProductoCont,
    getProductoImgs,
    addProductoImg,
    deleteProductoImg,
    getReglasTemplates,
    addPReglaTemplate,
    updateReglaTemplate,
    deleteReglaTemplate,
    getRoomsRel,
    getSirvoyObjeto,
    sendPrepayMail,
    getBookingRooms,
    ordena,
    getBooking,
    updateCheck,
    addMov,
    updateMov,
    addMovItem,
    addMovPago,
    updateMovItem,
    updateMovPago,
    delMovItem,
    delMovPago,
    traeCuerpoMov,
    addDoc,
    getStock,
    getCuentas,
    updateCabecera,
    checkCabecera,
    validaBnumber,
    getBnumber,
    addBnumber,
    updateBnumber,
    linkBnumber,
    getBookingBnumbers,
    getBookingCabeceras,
    getOrdenesPago,
    getOrdenPago,
    getLocations,
    getSurfLevels,
    getEnquiry,
    updateEnquiryStat,
    addCabeceraEnquiryRel,
    delCabeceraEnquiryRel,
    traeCabeceraEnquiryRel,
    getSirvoyMovData,
    traeParticipantes,
    traeAssets,
    addParticipante,
    updateParticipante,
    deleteParticipante,
    asistioParticipante,
    assetParticipante,
    getTickets,
    getTicket,
    sendTicket,
    setOrdenCargada,
    getCashbook,
    getCashbookComplete,
    getSupplierActs,
    getSupplierAct,
    addSupplierAct,
    updateSupplierAct,
    setSupplierInOut,
    getSupplierActPending,
    deleteSupplierAct,
    getSupplierContracts,
    addSupplierContract,
    updateSupplierContract,
    deleteSupplierContract,
    getEventos,
    getBookingCalendar,
    getSupplierReceipts,
    getSupplierReceipt,
    addSupplierReceipt,
    updateSupplierReceipt,
    deleteSupplierReceipt,
    getSupplierReceiptHs,
    addSupplierReceiptHs,
    deleteSupplierReceiptHs,
    getAssets,
    addAsset,
    updateAsset,
    deleteAsset,
    getSuscripciones,
    getSuscripcion,
    sendSuscripcion,
    getIni,
    getMeanPayments,
    getInforme,
    getCajaStat,
    getSuppliers,
    sendSupplier,
    delSupplier,
    searchItems,
    transfiereParticipante,
    getPartipantesNovedades,
    getLafiseTransactions,
    getEnquiries,
    getAvailableTickets,
    getSupplierReceiptsResume,
    getCotizacion,
    getActivities,
    updateMovStatus,
    getFacturaCompra,
    sendFactura,
    getAvailableSuscripciones,
    getActivitiesItems,
    cierraEventoReq,
    getActivitiesAnt,
    getFormats,
    addEvento,
    updateEvento,
    getEventosLista,
    cierraReceipt,
    getReceiptExtras,
    addReceiptExtras,
    updateReceiptExtras,
    deleteReceiptExtras,
    getSupplierHoursPending,
    getEvento,
    getSellItems,
    getFacturas,
    getBankAccounts,
    searchBanks,
    createBank,
    getBankAccountsFull,
    createBankAccount,
    updateBankAccount,
    deleteBankAccount,
    updateOrdenCuenta,
    batchPayOrdenes,
    submitTienda,
    getTienda,
    getIdentification,
    sendPedido,
}